import React, { useRef, useEffect } from "react";
import "./HolidayPageStyles.scss";
import { useNavigate } from "react-router-dom";

function HolidaysData({ holidays }) {
  const navigate = useNavigate();
  const DEFAULT_IMAGE = `${process.env.REACT_APP_IMG_URL}images/files-test/1734705843913.jpeg`;

  const handleClick = (articleId) => {
    if (articleId !== "") {
      navigate(`/article/${articleId}`);
    }
  };

  const scrollContainers = useRef([]);

  useEffect(() => {
    scrollContainers.current.forEach((container) => {
      if (!container) return;

      let isDown = false;
      let startX;
      let scrollLeft;

      const handleMouseDown = (e) => {
        isDown = true;
        container.classList.add("dragging");
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
      };

      const handleMouseLeave = () => {
        isDown = false;
        container.classList.remove("dragging");
      };

      const handleMouseUp = () => {
        isDown = false;
        container.classList.remove("dragging");
      };

      const handleMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 4; 
        container.scrollLeft = scrollLeft - walk;
      };

      container.addEventListener("mousedown", handleMouseDown);
      container.addEventListener("mouseleave", handleMouseLeave);
      container.addEventListener("mouseup", handleMouseUp);
      container.addEventListener("mousemove", handleMouseMove);

      return () => {
        container.removeEventListener("mousedown", handleMouseDown);
        container.removeEventListener("mouseleave", handleMouseLeave);
        container.removeEventListener("mouseup", handleMouseUp);
        container.removeEventListener("mousemove", handleMouseMove);
      };
    });
  }, [holidays]);

  if (!holidays) {
    return <p>No holidays available for the selected category.</p>;
  }

  const nonEmptyMonths = holidays.filter((month) => month.length > 0);

  if (nonEmptyMonths.length === 0) {
    return <p>No holidays available for the selected category.</p>;
  }

  return (
    <div className="mt-5 mb-5">
      <div className="container">
        <div className="row g-4">
          {nonEmptyMonths.map((month, index) => {
            const firstHolidayDate = new Date(month[0].date);
            return (
              <div className="row g-4" key={index}>
                <div className="border shadow rounded-lg h-100" style={{ minWidth: "10rem" }}>
                  <div className="card-body">
                    <p className="card-text month-name mt-2">
                      {firstHolidayDate.toLocaleString("en-US", { month: "long" })}
                    </p>
                    <div
                      ref={(el) => (scrollContainers.current[index] = el)}
                      className="d-flex overflow-auto scroll-smooth custom-scrollbar"
                      style={{
                        gap: "1rem",
                        scrollSnapType: "x mandatory",
                        WebkitOverflowScrolling: "touch",
                        cursor: "grab",
                      }}
                    >
                      {month.map((holiday, i) => (
                        <div
                          key={i}
                          className="p-3 border rounded shadow-sm flex-shrink-0"
                          style={{
                            minWidth: "12rem",
                            scrollSnapAlign: "start",
                            backgroundColor: "#fffdf9",
                          }}
                          onClick={() => handleClick(holiday?.article)}
                        >
                          <img
                            src={holiday.image || DEFAULT_IMAGE}
                            alt={holiday.title}
                            className="w-44 aspect-square object-cover rounded img-fluid holiday-image"
                            style={{
                              WebkitUserDrag: "none",
                              WebkitTouchCallout: "none",
                            }}
                          />
                          <div className="flex flex-col items-center mt-2 text-center">
                            <strong className="block">
                              {holiday.title.length > 19
                                ? holiday.title.slice(0, 19) + ".."
                                : holiday.title}
                            </strong>
                            <div>{holiday.date}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default HolidaysData;
